import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4 pb-0" }
const _hoisted_5 = ["onDragstart", "onDragend", "onDrop"]
const _hoisted_6 = { class: "card-body p-5" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = ["onDragstart", "onDragend", "onDrop"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Grid Drag & Drop", -1)),
          _createElementVNode("div", {
            class: "row js-grid cursor-move",
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drags.slice(0, 8), (drag, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-lg-3 col-sm-6",
                key: drag,
                onDragstart: ($event: any) => (_ctx.dragStart(index)),
                onDragend: ($event: any) => (_ctx.dragEnd(index)),
                onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onDrop: ($event: any) => (_ctx.dragDrop(index)),
                draggable: "true"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                  'card border-0 rounded-3 mb-4 text-center bg-for-dark-mode',
                  drag.bgClass,
                ])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h4", {
                      class: _normalizeClass(['fs-18 fw-semibold mb-0', drag.texColor])
                    }, _toDisplayString(drag.title), 3)
                  ])
                ], 2)
              ], 40, _hoisted_5))
            }), 128))
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "List Drag & Drop", -1)),
          _createElementVNode("ul", {
            class: "ps-0 mb-0 list-unstyled o-sortable cursor-move",
            onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drags, (drag, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: drag,
                onDragstart: ($event: any) => (_ctx.dragStart(index)),
                onDragend: ($event: any) => (_ctx.dragEnd(index)),
                onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                onDrop: ($event: any) => (_ctx.dragDrop(index)),
                draggable: "true",
                class: _normalizeClass(['p-4 rounded-2 mb-3', drag.bgClass])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(['fs-16 fw-semibold', drag.texColor])
                }, _toDisplayString(drag.title), 3)
              ], 42, _hoisted_10))
            }), 128))
          ], 32)
        ])
      ])
    ])
  ]))
}